exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.benefit-message[data-v-4811d454] {\n  font-size: 20px;\n  font-weight: bold;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  max-width: 960px;\n  width: 100%;\n  border-radius: 24px;\n  color: #ffffff;\n  background: -webkit-gradient(linear, left top, right top, from(#D70370), to(#A81FF8));\n  background: linear-gradient(to right, #D70370, #A81FF8);\n  padding: 32px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4811d454","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LP/atoms/GradationMessage.vue
// module id = DVSe
// module chunks = 3